const getVariantCartQuantity = async (variantId) => {
    const response = await fetch(window.Shopify.routes.root + 'cart.js');
    const data = await response.json();
  
    const item = data.items.find(item => item.id == variantId);
    if (item) {
      return { "quantity": item.quantity, "key": item.key };
    } else {
      console.log('No item found with variantId', variantId);
    }
  
    return 0;
  };
  
  const removeVariant = async (variantId) => {
    const item = await getVariantCartQuantity(variantId);
    if (item.quantity === 0) return;
  
    try {
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'id': `${variantId}`, 'quantity': item.quantity - 1 }),
      });

      const header = document.querySelector('.section-header');

      if(header) {
        const headerId = header.id.split('shopify-section-')[1];
        updateSection(headerId);
      }
    } catch (error) {
      console.log(error);
    }
  };
  
  function handleCheckboxChange(event, variantId) {
    const checkbox = event.target;
    if (event.target.checked) {
      try {
        // Get the value of the data-product-button-id attribute
        const buttonId = checkbox.getAttribute('data-product-button-id');
  
        // Find the button with the corresponding id
        const button = document.getElementById(buttonId);
  
        // Check if the button exists
        if (button) {
          // Click the button
          button.click();
        } else {
          console.warn(`Button with id "${buttonId}" not found.`);
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      try {
        removeVariant(variantId);
      } catch (error) {
        console.log(error);
      }
    }
  }
  
  // Function to update the section (used to update the cart icon when removing a variant)
  const updateSection = (sectionId) => {
    // Construct the URL for the Section Rendering API
    const url = `/?section_id=${sectionId}`;
  
    // Make an AJAX request to fetch the updated section HTML
    fetch(url)
      .then(response => response.text())
      .then(html => {
        // Parse the HTML response
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
  
        // Find the new section content
        const newSectionContent = doc.querySelector(`#shopify-section-${sectionId}`);
  
        // Find the existing section in the current document
        const existingSection = document.querySelector(`#shopify-section-${sectionId}`);
  
        // Replace the existing section's HTML with the new content
        if (existingSection && newSectionContent) {
          existingSection.innerHTML = newSectionContent.innerHTML;
          console.log('Section updated successfully');
        } else {
          console.error('Section not found in the response or the current document');
        }
      })
      .catch(error => {
        console.error('Error fetching the section:', error);
      });
  };